import Vue from 'vue';
// import axios from 'axios';
// import VueAxios from 'vue-axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es';
import VueI18n from 'vue-i18n';
import i18n from '@/locales';
import App from './App.vue';
import store from './store';
import ApiService from './api/ApiServices';

ApiService.init(process.env.VUE_APP_URLAPI);

// Vue.use(VueAxios, axios);

Vue.use(ElementUI, {
  locale,
});

Vue.config.productionTip = false;
Vue.use(VueI18n);

new Vue({
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
